{
  "refresh": "Refresh",
  "observed": "Observed {{when}}",
  "banner": {
    "okTitle": "All systems normal",
    "okText": "Workers are running, the queue is moving and no jobs have failed.",
    "attentionTitle": "Needs attention"
  },
  "tiles": {
    "workers": "Workers live",
    "noHeartbeat": "No heartbeat yet",
    "heartbeatNow": "Last heartbeat just now",
    "heartbeat": "Last heartbeat {{age}} ago",
    "projection": "Changes not yet visible to agents",
    "projectionNote": "Projection lag in commits",
    "failedJobs": "Failed jobs",
    "nothingToRetry": "Nothing to retry",
    "holdingProjection": "Holding back the projection",
    "needRetry": "Need an operator to retry",
    "waiting": "Proposals waiting",
    "oldestWaiting": "Oldest waiting {{age}}",
    "queueClear": "Queue is clear",
    "activeLessons": "Active lessons",
    "searches": "{{count}} searches in 30 days",
    "staleOrDisputed": "Stale or disputed",
    "expiring": "{{count}} expiring within 14 days",
    "unused": "Unused for 30 days",
    "unusedNote": "Active lessons no search returned",
    "judgeErrors": "Judge errors (24h)",
    "judge": "judge",
    "fixture": "fixture"
  },
  "jobs": {
    "title": "Failed jobs",
    "none": "No failed jobs.",
    "blocksProjection": "Blocks projection",
    "noError": "No error recorded",
    "attempts": "{{attempts}}/{{max}} attempts",
    "retry": "Retry",
    "retried": "Job {{id}} is {{state}}.",
    "retryFailed": "The job could not be retried."
  },
  "review": {
    "title": "Review backlog",
    "waiting": "Waiting",
    "decisions": "Decisions in 7 days",
    "none": "None"
  },
  "lessons": {
    "flaggedTitle": "Lessons agents flagged",
    "flaggedNote": "Marked wrong or outdated in the last 30 days.",
    "flaggedEmpty": "No lessons flagged by agents.",
    "attentionTitle": "Stale or disputed lessons",
    "attentionEmpty": "None. Lessons become stale when their source changes or their validity window ends.",
    "unusedTitle": "Lessons no search returned in 30 days",
    "unusedEmpty": "Every active lesson was retrieved recently.",
    "wrong": "Wrong · {{count}}",
    "outdated": "Outdated · {{count}}",
    "lastRetrieved": "Last retrieved {{when}}",
    "neverRetrieved": "Never retrieved",
    "since": "Since {{when}}",
    "flaggedAt": "Flagged {{when}}"
  },
  "connections": {
    "title": "Source connections",
    "none": "No active source connections.",
    "lastSuccess": "Last success {{when}}",
    "never": "never",
    "failedRuns": "{{count}} failed runs in 24h"
  },
  "footer": {
    "retention": "Retention: usage and job history older than {{days}} days is removed; audit events and records are kept.",
    "prometheus": "Prometheus:",
    "probe": "Unauthenticated probe:"
  },
  "error": {
    "title": "Health report unavailable",
    "text": "The memory service did not return its health report.",
    "fetchFailed": "Could not load the health report."
  }
}
